
import { useState } from 'react';

export function useInvoiceDialogs() {
  const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [actionInvoiceId, setActionInvoiceId] = useState<string | null>(null);

  return {
    paymentDialogOpen,
    setPaymentDialogOpen,
    cancelDialogOpen,
    setCancelDialogOpen,
    actionInvoiceId,
    setActionInvoiceId,
  };
}
